<template src='./dynamicInput.pug' lang="pug"></template>

<script>
import vSelect from 'vue-select'
import { TheMask } from 'vue-the-mask'
import Datepicker from 'vuejs-datepicker'
import idioma from '../../../../build/language/index'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'

export default {
  name: 'DynamicInput',

  components: {
    vSelect,
    TheMask,
    Datepicker
  },

  props: {
    // representa o label do input
    inputName: {
      type: String,
      required: true
    },
    // representa a TAG unica para o input, para fins de $refs
    inputTag: {
      type: String,
      required: true
    },
    // representa o tipo do input
    inputType: {
      type: String,
      required: true
    },
    // representa o valor incial do input gerado
    inputValue: {
      required: true
    },
    // representa a máscara para o input
    inputMask: {
      type: String
    },
    // representa a máscara para o input
    inputValidator: {
      type: String
    },
    // representa a máscara para o input
    inputTipoValores: {
      type: Array
    }
  },

  data () {
    return {
      invalid: false,
      // utilizado para instanciar o locale do datepicker
      inputMaskModel: null,
      inputValueSelect: null,
      // utilizado como model do componente
      instantValue: null,
      // referencia o datepicker, quando presente
      inputDate: null,
      // campos de validação
      message: null,
      toDate: new Date('December 31, 1999 23:59:59'),
      fromDate: new Date('December 31, 2999 23:59:59')
    }
  },

  computed: {
    // retorna o idioma para o datepicker
    datePickerLanguage () {
      return idioma.getDatePickerLanguageObject()
    },
    // flag para tipo do input à ser exibido
    defineInput () {
      if (this.inputType === 'STRING' && !this.inputMask) {
        return 1
      } else if (this.inputType === 'NUMBER' && !this.inputMask) {
        return 2
      } else if (this.inputType === 'DATE') {
        return 3
      } else if (this.inputType === 'COMBO') {
        return 4
      } else {
        return 0
      }
    },

    defineId () {
      if (this.inputType === 'STRING' && !this.inputMask) {
        return 'dynamicInputItem' + this.inputTag
      } else if (this.inputType === 'NUMBER' && !this.inputMask) {
        return 'dynamicInputNumberItem' + this.inputTag
      } else if (this.inputType === 'DATE') {
        return 'dynamicPickerDate' + this.inputTag
      } else if (this.inputType === 'COMBO') {
        return 'dynamicSelectItem' + this.inputTag
      } else {
        return 'dynamicMaskedItem' + this.inputTag
      }
    }
  },

  methods: {
    // Evento disparado quando o usuário entra com algum valor em algum dos inputs
    trackEvent (e) {
      trackAnalyticsEvent(this, 'dynamic-input', 'on-input-event', e.currentTarget.id)
    },
    // validação global do datepicker
    validateDate () {
      return this.inputDate !== null
    },

    isInputInvalid () {
      if (this.inputValidator && this.inputValue) {
        let regexp = new RegExp(this.inputValidator)
        if (!regexp.test(this.inputValue)) {
          this.message = this.$t('estabelecimentos.erro.atributoValidacaoFail')
          return true
        }
      }
      this.message = null
      return false
    }
  },

  mounted () {
    let currentInput = document.getElementById(this.defineId)
    if (currentInput) {
      if (this.inputType === 'STRING' || this.inputType === 'NUMBER') {
        currentInput.addEventListener('blur', () => {
          this.invalid = this.isInputInvalid()
          this.$emit('input-invalid', this.invalid)
        })
      } else if (this.inputType === 'COMBO') {
        this.inputValueSelect = this.inputValue ? this.inputValue : this.$t('validacao.select.placeholder')
      }
      if (this.defineInput === 0) {
        this.inputMaskModel = this.inputValue
      }

      // atribuições dinâmicas para datepicker
      if (this.inputType === 'DATE') {
        this.inputDate = this.inputValue || null
        currentInput.classList.remove('date-picker')
        currentInput.style.border = 'none'
        currentInput.style.height = '28px'
        currentInput.style.width = '90%'
        currentInput.setAttribute('autocomplete', 'off')
        currentInput.addEventListener('blur', () => {
          this.validateDate()
        })
      }
    }

    // Adiciona um valor default em cada select box, que deverá ser setado como null
    // antes da criação do estabelecimento.
    if (this.inputTipoValores && this.inputTipoValores.length > 0) {
      this.inputTipoValores.unshift({ valor: this.$t('validacao.select.placeholder') })
    }
  }
}
</script>

<style scoped>
.datepicker-input {
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 5px;
  display: inline;
  margin-left: 10px;
}

.datepicker-wrapper {
  display: inline !important;
}

.datepicker-wrapper div:first-child {
  display: inline !important;
}

.wrapperClass div:first-child {
  display: inline !important;
}

.wrapperClass {
  display: inline !important;
}

/* DatePicker*/
.date-picker-dynamic {
  border: none;
  height: 100%;
  width: 30%;
}

.vdp-datepicker {
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 3px 8px;
  margin-right: 10px;
}

.vdp-datepicker-margin-top {
  margin-top: 10px;
}

.second-date-picker {
  margin-left: 10px;
}

.second-date-picker .vdp-datepicker__calendar {
  margin-left: 180px;
}

.vdp-datepicker__calendar {
  padding: 5px;
}

.vdp-datepicker__calendar header span {
  font-family: 'Inter', sans-serif;
font-weight: 700;
}

.vdp-datepicker__calendar .cell {
  height: 35px !important;
  line-height: 35px !important;
}

.vdp-datepicker__calendar .cell.day-header {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  color: #8c8c8c;
  height: 35px;
  line-height: 35px;
}

.vdp-datepicker__calendar .cell.selected,
.vdp-datepicker__calendar .cell.selected.highlighted,
.vdp-datepicker__calendar .cell.selected:hover {
  background: #40b9bb !important;
  color: #fff !important;
  border-radius: 5px;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #40b9bb !important;
  border-radius: 5px;
}

.vdp-datepicker__calendar .disabled {
  color: #8c8c8c !important;
}

.vdp-datepicker__calendar .cell.today {
  background-image: url('../../../assets/icones_app/today-signal.png') !important;
  background-repeat: no-repeat !important;
  background-position: 30px 20px !important;
}

.vdp-datepicker__calendar {
  z-index: 3!important;
}
.is-danger-dynamic {
  border-color: #ff3860 !important;
}
</style>



// WEBPACK FOOTER //
// DynamicInput.vue?63ef4584